<template>
    <div class="right-container">
        <p class="right-h2">关于项目</p>
        <p class="right-h3">项目新增文件</p>
        <p class="right-content">应遵循以下规则：</p>
        <ul>
            <li>代码文件的编码格式统一为utf-8</li>
            <li>所有文件及文件夹名中不得包含大写字母，一般只使用小写英文单词</li>
            <li>图片素材建议以数字序列进行命名，例如01.png，02.png，03.png</li>
            <li>编写css时，可以使用CSS预处理器编写，如scss或less，然后自动生成css文件</li>
        </ul>
        <p class="right-h3">项目编写中</p>
        <p class="right-content">应遵循以下规则：</p>
        <ul>
            <li>元素标签、属性等应使用小写字母，尽量不使用数字</li>
            <li>class属性值为多单词，应使用中横线分隔，避免使用驼峰</li>
            <li>id属性值为多单词，应使用下划线分隔，可使用驼峰，避免使用中横线和首字母大写</li>
            <li>代码换行时，应设置开发工具缩进为两个空格</li>
            <li>js功能代码片段，需简单注释其对应功能所属，复杂逻辑尽量注释详尽</li>
            <li>政府项目，html部分也应添加注释，每个模块在开头和结尾处注释其对应模块名</li>
            <li>普通页面css应写在style.scss中，公共部分应写在common.scss中，重置样式写在reset.css中，公共js部分应写在public.js中</li>
            <li>页面中如有通过css展示状态变化，则变化的高亮或状态的class名需为active</li>
            <li>js操作样式时，应操作class属性，尽量不要直接操作style属性，尤其是多次操作style属性时</li>
        </ul>
        <p class="right-h3">项目编写完成</p>
        <p class="right-content">应遵循以下规则：</p>
        <ul>
            <li>编写完的html、css、js或其他前端代码文件，执行格式化，代码缩进为两个空格</li>
            <li>一般需要压缩static/img目录中图片文件大小，在线压缩地址：https://tinypng.com/</li>
            <li>css预处理器配置文件设置生成 .min.css 压缩文件，生产环境中应尽量使用压缩后的css和js</li>
            <li>小程序项目中，能预知图片素材为在线获取的图片，应从源码包里删除，转移到线上引用</li>
            <li>项目中如有生成sourcemap，在生产环境中应删除或备份到其他位置</li>
            <li>已知页面逻辑的情况下，做好各个页面的超链接，能保证业务流程在静态代码中走得通</li>
        </ul>
        <p class="right-h3">后端数据交互</p>
        <p class="right-content">应遵循以下规则：</p>
        <ul>
            <li>如产品需求文档不明确、后端接口字段语义不明、多个关联的接口同个类目返回的字段数目以及名称不统一、表单使用 get 请求等，应该主动提出建议，并让对应负责人沟通，统一规范</li>
            <li>如后端不同状态下返回的数据类型不一致，应主动提出让后端修改，例如：有数据时返回数组，但没数据时返回null或false等的，应返回空数组；有数据时返回对象，但没数据时返回null或false等的，应返回空对象；有数据时返回应有字段，无数据时却缺少了某个必要字段，应返回完整字段。</li>
            <li>H5项目，在提测前，需引入VConsole.js，方便测试开发调试</li>
        </ul>
        <p class="right-h3">整体项目优化</p>
        <p class="right-content">应遵循以下规则：</p>
        <ul>
            <li>切忌偷懒</li>
            <li>有些地方感觉有不合符大众思维逻辑的甚至反人类的，应主动提出或给出建议</li>
            <li>很多小问题影响到体验性的，尽管产品不要求，前端也应该自主的实现</li>
            <li>网络请求失败、后端返回错误信息时，应将错误信息弹出；用户操作相关的网络请求成功时，应弹出符合当前操作对应的提示语，如 登录成功、刷新成功，如不太明确，可使用“操作成功”</li>
        </ul>
        <p class="right-h3">处理维护单</p>
        <p class="right-content">应遵循以下规则：</p>
        <ul>
            <li>维护企业站项目时，连上FTP后，应第一时间备份整站源码至电脑本地（upload文件夹过大时，可不下载）</li>
            <li>维护功能站项目时，禁止使用FTP，应使用SVN工具进行操作（老项目无SVN除外，使用FTP也应遵循上一点）</li>
            <li>FTP修改文件时，在整站备份好后，如有修改文件，应再次备份文件并修改文件名，上传到相同目录中，如修改index.html，则先将index.html下载重命名为index.html20200806，然后将index.html20200806上传到服务器中以作为备份，备份文件名应为后缀加上YYYYMMDD</li>
        </ul>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>

</style>